export { GearCard } from './GearCard';
export type { GearCardProps } from './GearCard';
